<template>
  <div :class="$options.name" class="twt-flex tw:flex-col tw:gap-2 tw:w-full">
    <div class="tw:flex tw:flex-col tw:gap-2">
      <EdroneSelect
        v-if="user.isDev"
        :options="langOptions"
        :placeholder="trans._menu.item.language"
        :selected-options="selectedLangOption"
        @select="onLangChange"
      />
      <EdroneTabGroup
        v-if="user.canSetIsDev"
        class="tw:!w-full"
        type="border"
        unique-id="36be3c3b-252a-46eb-9419-a5f761e984e2"
      >
        <EdroneTab
          :active="!user.isDev"
          class="tw:!w-1/2"
          type="border"
          unique-id="fadf772b-ac10-48ba-b075-2cad5b45903e"
          @click="handleClickRegular"
        >
          Regular
        </EdroneTab>
        <EdroneTab
          :active="user.isDev"
          class="tw:!w-1/2"
          type="border"
          unique-id="708889d2-111b-47ca-add4-07d581dd964a"
          @click="handleClickDev"
        >
          isDev
        </EdroneTab>
      </EdroneTabGroup>
      <div v-if="user.isDev" class="tw:flex tw:gap-1 tw:max-w-full tw:max-h-10">
        <EdroneSelect
          :allow-empty="false"
          :disabled="!jiraTemplates.length"
          :options="jiraTemplates"
          :selected-options="selectedTemplate"
          class="tw:flex-1"
          style="max-width: calc(100% - 2.75rem)"
          @select="onTemplateChange"
        />
        <EdroneButtonIcon :disabled="!selectedTemplate.value" type="border" @click="createJira(selectedTemplate)">
          <font-awesome-icon icon="fa-light fa-arrow-up-right" />
        </EdroneButtonIcon>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, ref } from "vue";
import EdroneSelect from "edrone-components/EdroneSelect.vue";
import EdroneTabGroup from "edrone-components/EdroneTabGroup.vue";
import EdroneButtonIcon from "edrone-components/EdroneButtonIcon.vue";
import EdroneTab from "edrone-components/EdroneTab.vue";
import { onLangChange, handleClickRegular, handleClickDev } from "vue-app/api/menu/account.ts";
import { getJiraTemplates, createJira, jiraTemplates } from "vue-app/api/menu/jiras.ts";

export default defineComponent({
  name: "MainMenuSettingsDeveloperMode",
  components: {
    EdroneTab,
    EdroneButtonIcon,
    EdroneTabGroup,
    EdroneSelect,
  },
  setup() {
    const user = window.EDRONE_CONTEXT.user;

    const langOptions = ref([
      { value: "en", name: "English" },
      { value: "pl", name: "Polski" },
      { value: "es", name: "Español" },
      { value: "pt", name: "Portuguese" },
    ]);

    if (user.isDev) {
      langOptions.value.push({ value: "ach", name: "Crowdin" });
    }

    const selectedLangOption = computed(() => {
      return langOptions.value.find((option) => option.value === user.lang);
    });

    const selectedTemplate = ref({ value: "", name: "JIRA: Select template" });

    function onTemplateChange(option) {
      selectedTemplate.value = option;
    }

    onMounted(async () => {
      await getJiraTemplates();
    });

    return {
      user,
      langOptions,
      selectedLangOption,
      onLangChange,
      handleClickRegular,
      handleClickDev,
      jiraTemplates,
      selectedTemplate,
      onTemplateChange,
      createJira,
    };
  },
});
</script>
